import type { RepairTruck } from '@otw/models/logistics'
import type { VehicleTimeline } from '@otw/models/timeline'

function maxPositiveMs(...values: Array<number | null | undefined>): number | null {
  const nums = values.filter((v): v is number => typeof v === 'number' && v > 0)
  if (nums.length === 0) return null
  return Math.max(...nums)
}

/** Latest `work_notes[].timestamp` on a repair_trucks document. */
export function getLastRepairWorkNotesUpdateMs(repairTruck: RepairTruck | null | undefined): number | null {
  const notes = repairTruck?.work_notes ?? []
  if (notes.length === 0) return null

  let latestMs = 0
  notes.forEach((note) => {
    const ts = note.timestamp?.toMillis?.() ?? 0
    if (ts > latestMs) latestMs = ts
  })

  return latestMs > 0 ? latestMs : null
}

/** Latest `notes[].created_at` on a vehicle_timeline document (TimelineDialog free-form notes). */
export function getLastVehicleTimelineNotesUpdateMs(
  timeline: VehicleTimeline | null | undefined,
): number | null {
  const notes = timeline?.notes ?? []
  if (notes.length === 0) return null

  let latestMs = 0
  notes.forEach((note) => {
    const ts = note.created_at?.toMillis?.() ?? 0
    if (ts > latestMs) latestMs = ts
  })

  return latestMs > 0 ? latestMs : null
}

/** "Last update" for repair grids: repair work notes plus vehicle timeline notes from TimelineDialog. */
export function getLastRepairGridUpdateMs(
  repairTruck: RepairTruck | null | undefined,
  vehicleTimelineNotesMs: number | null | undefined,
): number | null {
  return maxPositiveMs(getLastRepairWorkNotesUpdateMs(repairTruck), vehicleTimelineNotesMs ?? undefined)
}
